import { CircularProgress } from '@mui/material'
import { ChangeEvent, useEffect } from 'react'
import { useActions, useAppSelector } from 'store/hooks'
import { TextField } from 'ui'
import { DebouncedState } from 'use-debounce'

import style from './OrderDateDealerCode.module.scss'

type TOrderDateDealerCode = {
  setButtonDisabled: (value: boolean) => void
  debounceDealerChecking: DebouncedState<() => void>
  dealerDataLoading: boolean
  errorText: string | null
  setErrorText: (value: string | null) => void
  dealerName?: string
  onResetDealer?: () => void
}
export function OrderDateDealerCode({
  setButtonDisabled,
  debounceDealerChecking,
  dealerDataLoading,
  errorText,
  setErrorText,
  dealerName,
  onResetDealer,
}: TOrderDateDealerCode) {
  const { setDialerCodeOrder } = useActions()

  const currentEditForm = useAppSelector(
    state => state.orderForm.currentEditForm,
  )
  const dealerCode = useAppSelector(
    state => state.orderForm.forms[currentEditForm].dealerCode,
  )

  useEffect(() => {
    if (dealerCode.length) {
      debounceDealerChecking()
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleDealerCodeChange = (e: ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value
    const code = inputValue.replace(/[^A-Z0-9]/gi, '').toUpperCase()

    if (dealerName) {
      onResetDealer?.()
    }

    setDialerCodeOrder(code)

    if (code !== dealerCode) {
      if (code.length) {
        debounceDealerChecking()
        return
      }

      setErrorText(null)

      setButtonDisabled(false)
    }
  }

  const dillerHelperText = `Заполните это поле, если хотите совершить
  покупку у конкретной компании. Уточните код у вашего менеджера.`

  return (
    <div className={style.dealerBlock}>
      {dealerDataLoading && (
        <CircularProgress className={style.loader} size={25} />
      )}
      <TextField
        name='diller_code'
        type='text'
        label='Код дилера'
        className={style.dillerCode}
        onChange={handleDealerCodeChange}
        value={dealerCode}
        error={!!errorText?.length}
        helperText={
          errorText ||
          (dealerName && `Выбранный дилер: ${dealerName}`) ||
          dillerHelperText
        }
        inputProps={{ maxLength: 10, autoComplete: 'off' }}
        data-testid='order-dealer-code'
      />
    </div>
  )
}
